/* The one sentence `SurveyActions` owns.
 *
 * It is drawn in three heads — the matrix's, the report's and the comparison's — and it was written
 * out byte for byte in `SurveysTab.module.css` and the pane's own sheet. One home, because a
 * failure notice that reads differently in two of the three places it can appear is worse than no
 * notice at all. */

.alert {
  flex: none;
  max-width: var(--w-survey-alert);
  margin: var(--space-0);
  font-size: var(--fs-micro);
  font-weight: var(--fw-bold);
  line-height: var(--lh-normal);
  color: var(--danger-text-strong);
}
